module.exports = __webpack_public_path__ + "img/Luiz_1.c35b7301.png";